/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */

//vender
import React from "react";
import { connect } from "react-redux";
import "isomorphic-fetch";
import i18n from "i18next";
import { Translation } from "react-i18next";
import { Helmet } from "react-helmet";
//components
import { SliderNavigation } from "../components/Slider";
import Section from "../components/Section";
import { PdtLeft, PdtRight } from "../components/PdtBlock";
import PdtBlockList from "../components/PdtBlockList";
import SizeGuide from "../components/SizeGuide";
import Tab from "../components/Tab";
import MobileTab from "../components/MobileTab";
import MobileGallery from "../components/MobileGallery";
import isArray from "../function/isArray";

//models
import {
  product,
  login,
  countryList,
  browsingHistory,
  cart,
  loginPopup,
  mobileMenu,
  recommendation,
  myFav
} from "../models";

//constants
import { ROOT, HOST_URL } from "../constants";

//images
import ArrowLeft from "../images/common/ui/arrow_l.png";
import shareImage from "../images/share.jpg";
import writeCookie from "../function/writeCookie";
import getCookie from "../function/getCookie";
import urlReplace from "../function/replaceUrl";
import EnlargeGallery from "../components/EnlargeGallery";
import isUrlEn from "../function/isUrlEn";
import Recommendation from "../components/Recommendation";
import ReservationPopup from "../components/ReservationPopup";
import Similar from "../components/Similar";

window.HOST_URL = HOST_URL;

class ProductDetail extends React.Component {
  state = {
    lang: "zhTW",
    recentlyViewed: [],
    recentlyViewedLoadComplete: false
  };

  handleClickLang(event) {
    const {
      fetchProduct,
      fetchCountryList,
      fetchBrowsingHistory,
      fetchRecommendation,
      activeCountry,
      fetchDutyTax,
      fetchMenuCountryList
    } = this.props;
    const url = window.location.pathname;
    const cbu = url.substring(url.lastIndexOf("/") + 1);

    if (event.target.value === "en") {
      i18n.changeLanguage("en");
      writeCookie("eshop-hk-language", "en");
      this.setState({
        lang: "en"
      });
      /*塞en回url字串*/
      urlReplace(window.location.pathname, "tc", "en");
    } else {
      i18n.changeLanguage("zhTW"); //繁體
      writeCookie("eshop-hk-language", "zh_HK"); //香港網站
      this.setState({
        lang: "zhTW"
      });
      /*塞tc回url字串*/
      urlReplace(window.location.pathname, "en", "tc");
    }

    fetchProduct(cbu); //切換語系, 取得英文產品資料
    fetchCountryList(); //切換語系, 取得英文國家列表
    fetchMenuCountryList(); //切換語系, 取得貨幣menu英文國家列表
    fetchBrowsingHistory(); //切換語系, 取得最近瀏覽
    fetchRecommendation();
    if (activeCountry !== "DEFAULT") {
      fetchDutyTax(activeCountry);
    }
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    const url = window.location.pathname;
    const cbu = url.substring(url.lastIndexOf("/") + 1);
    const browserLang = window.navigator.language;
    // console.log("browserLang", browserLang);
    // console.log("cbu", cbu);
    window.cbu = cbu;
    /*先抓URL判斷語系*/
    isUrlEn(url);
    const lang = getCookie("hk-emphasis-language"); //重整頁面先到cookie拿語系
    const isCheckoutPage = false;
    const isProductDetailsPage = true;
    const {
      fetchProduct,
      fetchBrowsingHistory,
      fetchCountryList,
      fetchUser,
      showLoginPopup,
      fetchCart,
      showMobileMenu,
      fetchMenuCountryList,
      fetchMyFavList
    } = this.props;

    if (lang === "en") {
      i18n.changeLanguage("en");
      this.setState({
        lang: "en"
      });
      if (window.OneTrust) window.OneTrust.changeLanguage("en");
    } else {
      i18n.changeLanguage("zhTW"); //繁體
      this.setState({
        lang: "zhTW"
      });
    }

    window.addEventListener("message", event => {
      if (event.data === "emphasisSuccess") {
        showLoginPopup(false); //登入成功後便關閉Popup畫面
        showMobileMenu(false); //登入成功後便關閉手機板Menu畫面
        fetchUser(isCheckoutPage, isProductDetailsPage);
      } else if (event.data === "RETURN_FIRST_PURCHASE_DONE") {
        // 2022/03/31以前執行FTV
        const now = new Date().getTime();
        const march31 = new Date("2022,03,31").getTime();
        if (now < march31) {
          this.handleFTV();
        }
      } else if (event.data === "VIEW_RECOMMENDATION_INSIDER") {
        this.setRecommendDataLayerEvent(
          "view_YMAL_widget_insider",
          this.props.recommendProductsInsider
        );
      }
      return;
    });

    fetchProduct(cbu);
    fetchBrowsingHistory();
    fetchCountryList();
    fetchMenuCountryList();
    fetchUser(isCheckoutPage, isProductDetailsPage);
    // fetchCart();
    fetchMyFavList();
    window.addEventListener("message", e => {
      if (e.data === "HEADER_UPDATE_WISHLIST") {
        fetchMyFavList();
      }
      if (e.data === "HEADER_UPDATE_MINI_CART") {
        fetchCart();
      }
      if (
        typeof e.data === "string" &&
        e.data.includes("HEADER_UPDATE_CURRENCY_CODE")
      ) {
        const currencyCode = e.data.replace("HEADER_UPDATE_CURRENCY_CODE_", "");
        const url = window.location.pathname;
        const cbu = url.substring(url.lastIndexOf("/") + 1);
        writeCookie("eshop-hk-currency-code", currencyCode);
        fetchProduct(cbu);
      }
    });
  }
  componentDidUpdate(prevProps) {}

  setRecommendDataLayerEvent = (eventName, products) => {
    const items = [];
    if (isArray(products)) {
      products.forEach(item => {
        const { name2, productCode, price, originalPrice, name } = item;
        const _price = price ? price.replace("HK$", "").replaceAll(",", "") : 0;
        const _originalPrice = originalPrice
          ? originalPrice.replace("HK$", "").replaceAll(",", "")
          : 0;
        const _discount = _originalPrice - _price;
        const dashFirstIndex = productCode.indexOf("-");
        const dashSecondIndex = productCode.indexOf("-", dashFirstIndex + 1);
        const _item_category = productCode.substring(
          dashFirstIndex - 1,
          dashFirstIndex
        );
        const _item_category2 = productCode.substring(
          dashFirstIndex + 1,
          dashSecondIndex
        );
        const _item_category3 = productCode.substring(
          dashSecondIndex + 1,
          productCode.length
        );
        const value = {
          item_brand: name,
          item_name: name2,
          item_id: productCode,
          price: _price,
          discount: _discount,
          item_category: _item_category,
          item_category2: _item_category2,
          item_category3: _item_category3,
          quantity: 1
        };
        items.push(value);
      });
    }
    const pushData = {
      event: eventName,
      ecommerce: {
        currency: "HKD",
        items: items
      }
    };
    if (window.dataLayer) {
      window.dataLayer.push(pushData);
    }
  };

  handleFTV = () => {
    // 判斷首次購物view_pdp
    const view_pdp = getCookie("view_pdp");
    if (!view_pdp) {
      writeCookie("view_pdp", "Y", false, 7);
    } else {
      if (view_pdp === "Y") {
        writeCookie("view_pdp", "N", false, 7);
        const view_emp = getCookie("view_emp");
        const dt = new Date().getTime();
        const hour24 = 24 * 60 * 60 * 1000;
        const in24hour = dt - Number(view_emp) < hour24;
        const purchase_emp = getCookie("purchase_emp");
        const subscription_emp = getCookie("subscription_emp");
        const isFirstPurchase = window.isFirstPurchase || false;

        if (isFirstPurchase && in24hour && !purchase_emp && !subscription_emp) {
          window.postMessage("SHOW_FIRST_PURCHASE", "*");
        }
      }
    }
  };

  render() {
    const { lang } = this.state;
    const { product } = this.props;
    const {
      gallery,
      details,
      info,
      matchingPdt,
      code,
      prevProductDetailUrl,
      nextProductDetailUrl,
      vmTagName,
      vmTagUrl,
      ui,
      activeOptionIndex,
      recommendProductsInsider
    } = this.props;
    const { recentlyViewed, recentlyViewedLoadComplete } = this.props;
    const url = window.location.pathname;
    const sku = url.substring(url.lastIndexOf("/") + 1);
    const language = lang === "en" ? "en" : "tc";
    const hasLv2 =
      ui.options[activeOptionIndex].option.display.hasOwnProperty("lv2");
    let sizeGuideAnchor = "";
    if (hasLv2) {
      sizeGuideAnchor =
        ui.options[activeOptionIndex].option.display.lv2.sizeGuideAnchor;
    }

    return (
      <>
        <Helmet>
          {/* SEO */}
          <title>
            {details.productName1 ? details.productName1 : ""}
            {details.productName2 ? " " + details.productName2 + " | " : ""}
            {lang === "en" ? "EMPHASIS" : "EMPHASIS官方網上珠寶店"}
          </title>
          <meta name="description" content={details.productDesc} />
          <link rel="canonical" href={window.location.href} />

          {/* 給facebook */}
          <meta property="og:title" content={`EMPHASIS官方網上珠寶店`} />
          <meta property="og:description" content={details.productDesc} />
          <meta property="og:url" content={window.location.href}></meta>
          <meta property="og:image" content={shareImage} />

          <meta
            name="google-site-verification"
            content="W8Ctb0Gaet-xkn145T91v7JDzBMJa_ijzqVPcE1DCD0"
          />
        </Helmet>
        <div id="header"></div>
        <div className="pageContent_wrap">
          {/* ---------------- top : 麵包屑和前後頁箭頭 -------------------------------*/}
          <div
            className="pdtDetailsTop_wrap content-wrapper-wider"
            id="pdtDetailsTop_wrap"
          >
            <div className="clearfix">
              <div className="float-left">
                {/* 麵包屑 */}
                {/* {vmTagName && vmTagUrl ? (
                  <div className="breadcrumb_wrap d-none d-md-block">
                    <a
                      className="breadcrumb__link"
                      href={this.state.lang === "en" ? "/en/home" : "/tc/home"}
                    >
                      <Translation>
                        {t => <span>{t("pdt.home")}</span>}
                      </Translation>
                    </a>
                    <a className="breadcrumb__link" href={vmTagUrl}>
                      <span>{vmTagName}</span>
                    </a>
                  </div>
                ) : (
                  ""
                )} */}
              </div>
              <div className="float-right">
                {prevProductDetailUrl !== undefined &&
                  prevProductDetailUrl !== null && (
                    <div
                      className="prevPdt_wrap"
                      style={{ marginRight: "5px" }}
                    >
                      <a
                        className="container_btn"
                        href={`${ROOT}${prevProductDetailUrl}`}
                        style={{
                          backgroundImage: `url(${ArrowLeft})`
                        }}
                      />
                      <div className="tip">
                        <Translation>
                          {t => <>{t("floatArrows.prev")}</>}
                        </Translation>
                      </div>
                    </div>
                  )}
                {nextProductDetailUrl !== undefined &&
                  nextProductDetailUrl !== null && (
                    <div className="nextPdt_wrap">
                      <a
                        className="container_btn"
                        href={`${ROOT}${nextProductDetailUrl}`}
                        style={{
                          backgroundImage: `url(${ArrowLeft})`
                        }}
                      />
                      <div className="tip">
                        <Translation>
                          {t => <>{t("floatArrows.next")}</>}
                        </Translation>
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </div>
          <div className="pdt-details content-wrapper-wider">
            <div className="pdt_wrap parent_forSticky">
              <div className="pdt_desktopL_wrap">
                <div className="top_wrap d-none d-md-table">
                  {(gallery !== undefined && <PdtLeft gallery={gallery} />) ||
                    null}
                </div>
                {(details.collection !== undefined && (
                  <Tab
                    info={info}
                    matchingPdt={matchingPdt}
                    details={details}
                  />
                )) ||
                  null}
              </div>
              {(gallery !== undefined && (
                <>
                  <MobileGallery gallery={gallery} />
                  <EnlargeGallery />
                </>
              )) ||
                null}
              {(details !== undefined && (
                <PdtRight
                  product={details}
                  productCbu={product.cbu}
                  language={language}
                />
              )) ||
                null}
            </div>
            {(details.collection !== undefined && (
              <MobileTab
                info={info}
                matchingPdt={matchingPdt}
                code={code}
                details={details}
              />
            )) ||
              null}
          </div>
          {/* <Section title="搭配型錄" className="shopTheLook_wrap">
            <ShopTheLook shopTheLook={shopTheLook} />
          </Section> */}

          {/* <section
            id="recommendation-wrap"
            className="recommendation_wrap"
          ></section> */}

          <div id="recommendation-wrap">
            <section className="recommendation_wrap">
              <div className="pdt-detail-section">
                <Similar />
                <Recommendation products={recommendProductsInsider} />
              </div>
            </section>
          </div>

          {/* {recentlyViewed && recentlyViewed.length > 0 && (
            <Section
              title={"section.recentlyViewed"}
              className="recentlyViewed_wrap"
            >
              <SliderNavigation
                name="recentlyViewed_wrap"
                recentlyViewed={recentlyViewed}
              >
                {recentlyViewedLoadComplete && (
                  <PdtBlockList
                    products={recentlyViewed}
                    productLoading={recentlyViewedLoadComplete}
                  />
                )}
              </SliderNavigation>
            </Section>
          )} */}
          {/* <Section title="更多其他系列" className="moreCollections_wrap">
            <SliderNavigation name="moreCollections_wrap">
              <CollectionBlockList collections={collections} />
            </SliderNavigation>
          </Section> */}
        </div>
        <SizeGuide sizeGuideAnchor={sizeGuideAnchor} />
        {details.itemId && this.props.toggleReservationPopup && (
          <ReservationPopup language={language} />
        )}
        <footer id="footer"></footer>
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    product: state.product.productBookingUnit,
    signed: state.login.signed,
    gallery: state.product.productBookingUnit.media.images,
    details: state.product.product,
    // shopTheLook: state.product.data.shopTheLook,
    // collections: state.product.data.collections,
    info: state.product.productBookingUnit.detail,
    matchingPdt: state.product.data.matchingPdt,
    code: state.product.product.code,
    prevProductDetailUrl: state.product.ui.display.prevProductDetailUrl,
    nextProductDetailUrl: state.product.ui.display.nextProductDetailUrl,
    countryCode: state.countryList.countryCode,
    recentlyViewed: state.browsingHistory.payload.browsingHistoryItems,
    recentlyViewedLoadComplete:
      state.browsingHistory.recentlyViewedLoadComplete,
    vmTagName: state.product.ui.display.vmTagName,
    vmTagUrl: state.product.ui.display.vmTagUrl,
    activeCountry: state.countryList.activeCountry,
    ui: state.product.ui,
    activeOptionIndex: state.product.activeOptionIndex,
    toggleReservationPopup: state.pickUpInStore.toggleReservationPopup,
    recommendProductsInsider: state.recommendation.recommendProductsInsider
  };
};

const mapDispatchToProps = () => {
  return {
    fetchProduct: cbu => product.actions.fetchProduct(cbu),
    fetchCart: () => cart.actions.fetchCart(),
    fetchCountryList: () => countryList.actions.fetchCountryList(),
    fetchMenuCountryList: () => countryList.actions.fetchMenuCountryList(),
    fetchUser: (isCheckoutPage, isProductDetailsPage) =>
      login.actions.fetchUser(isCheckoutPage, isProductDetailsPage),
    fetchDutyTax: countryCode => countryList.actions.fetchDutyTax(countryCode),
    fetchBrowsingHistory: () => browsingHistory.actions.fetchBrowsingHistory(),
    fetchRecommendation: () => recommendation.actions.fetchRecommendation(),
    showLoginPopup: bool => loginPopup.actions.showLoginPopup(bool),
    showMobileMenu: bool => mobileMenu.actions.showMobileMenu(bool),
    updateMyFav: (data, bool) => myFav.actions.updateMyFav(data, bool),
    fetchMyFavList: () => myFav.actions.fetchMyFavList()
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ProductDetail);
